<p>
  diary-week-view works!
</p>
